<template>
  <div class="tfw-course-list mt-3">
    <div class="d-flex justify-content-between mb-3">
      <div>
        <CButton color="primary" class="mr-2 mb-2" @click="getCourses()">Ai SEARCH</CButton>
        <CButton
          color="primary"
          class="mr-2 mb-2"
          @click="getCourses([1, 2, 3, 4, 5, 6, 7, 8, 9])"
          >LANGUAGE TRAINING</CButton
        >
        <CButton
          color="primary"
          class="mr-2 mb-2"
          @click="getCourses([10, 11, 12])"
          >HEALTH TRAINING</CButton
        >
        <CButton color="primary" class="mr-2 mb-2" @click="getCourses()">OTHER</CButton>
      </div>
      <div class="text-right">
        <CButton color="primary" :to="backURL">Back</CButton>
      </div>
    </div>
    <CRow class="mt-2">
      <CCol md="4" v-for="item of filteredCourses" :key="item.course_id">
        <CCard class="course-card">
          <img class="img-course" :src="item.thumbnail" />
          <CCardBody class="p-2 position-relative h-80">
            <div>
              <h6 class="text-2-truncate slc-title px-1" :title="item.name">
                {{ item.name }}
              </h6>
            </div>
            <div class="course-footer position-absolute bottom-0">
              <CButton
                v-if="item.course_id <= 12"
                variant="ghost"
                size="sm"
                color="primary text-white"
                class="px-1"
                :to="`/tfm/course/${item.course_id}`"
                >View Course</CButton
              >
              <CButton
                v-else
                variant="ghost"
                size="sm"
                color="primary text-white"
                class="px-1"
                >View Course</CButton
              >
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import CourseInfoVue from "@/containers/TFW/LandingPage/CourseInfo.vue";
import { CONSTANT } from "@/helpers/helper";
import { getScope, Role, appendAccessToken } from "@/helpers/helper";
export default {
  components: {
    CourseInfoVue,
  },
  data() {
    return {
      currentUserRole: getScope(),
      Role,
      filteredCourses: [],
    };
  },
  computed: {
    ...mapGetters([
      "noMoreDataFromCourseList",
      "isFetchingCourseList",
      "courseTemplate",
    ]),
    courseList() {
      const courses = CONSTANT.courses;
      return courses || [];
    },
    isCandidateRole() {
      return (
        this.currentUserRole === Role.customerCandidate ||
        this.currentUserRole === Role.systemCandidate
      );
    },
    backURL() {
      const historyBack = this.$router?.history?._startLocation;
      return this.isCandidateRole && historyBack ? historyBack : "/tfm";
    },
  },
  methods: {
    getCourses(id) {
      if (id) {
        const courses = [...this.courseList];
        this.filteredCourses = courses.filter((item) =>
          id.includes(item.course_id)
        );
      } else {
        this.filteredCourses = this.courseList;
      }
    },
  },
  async mounted() {
    await this.getCourses();
  },
};
</script>
<style lang="scss" scoped>
.text-2-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.slc-title {
  font-weight: 500;
  line-height: 1.235;
  font-size: 1.2rem;
}

.img-course {
  height: 200px;
}

.course-card {
  min-height: 250px;
}

.course-footer {
  bottom: 5px;
}
.h-80 {
  height: 90px;
}
</style>
